// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__15zsX","checkboxCol":"Table_checkboxCol__3wNyH","emailCol":"Table_emailCol__3e0uq","actionCol":"Table_actionCol__OvLfK"};